import { render, staticRenderFns } from "./mutilType.vue?vue&type=template&id=9ef8d5fa&scoped=true"
import script from "./mutilType.vue?vue&type=script&lang=js"
export * from "./mutilType.vue?vue&type=script&lang=js"
import style0 from "./mutilType.vue?vue&type=style&index=0&id=9ef8d5fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef8d5fa",
  null
  
)

export default component.exports